import { render } from "./GraficoProjetosPorSetor.vue?vue&type=template&id=d1fa3dc2&scoped=true"
import script from "./GraficoProjetosPorSetor.vue?vue&type=script&lang=js"
export * from "./GraficoProjetosPorSetor.vue?vue&type=script&lang=js"

import "./GraficoProjetosPorSetor.vue?vue&type=style&index=0&id=d1fa3dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fa3dc2"]])

export default __exports__